import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TasksAdminComponent } from './component/tasks.component';
import { SelectDocumentDialogComponent } from './component/task-details/select-document-dialog.component';
import { DictionaryFieldsModule, MasterDetailModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatInputModule as MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    TasksAdminComponent,
    SelectDocumentDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,

    CommonTranslationModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    MasterDetailModule,
    DictionaryFieldsModule,

    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
    MatInputModule
  ],


})
export class TasksModule {

}

